export default "__VITE_ASSET__DGZYVIwU__"